<div style="padding: 20px;">
  <div class="row">
    <div class="col-md-8"><input placeholder="Search" type="text" class="form-control"
    (input)="onSearchInput($event.target.value)"></div>
    <div style="text-align: right;margin-bottom: 0.5em;" class="col-md-4">
      <button class="btn btn-outline-primary" (click)="add()">Add</button></div>
    </div>
    <table class="table">
      <thead class="thead-light">
        <tr>
          <th scope="col">Key</th>
          <th scope="col" style="width: 10%;">Actions</th>
        </tr>
      </thead>
      <tbody>
        @for (rec of list; track rec) {
          <tr>
            <td>{{rec.key}}</td>
            <td><button (click)="editTranslation(rec)">Edit</button></td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <ng-template #translation>
    <div class="modal-header">
      <h2>Localization</h2>
      <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" (click)="modalRef.hide();">
        <span aria-hidden="true">X</span>
      </button>
    </div>
    <div class="modal-body">
      <form (ngSubmit)="f.form.valid && post(f)" #f="ngForm">
        <div class="row justify-content-center mt-3">
          @if (editedObject && editedObject.count>1) {
            <span
              style="color: red;padding: 15px;font-size: 12px;padding-top: 0;padding-bottom: 0;">*Note : This key
              is mapped to multiple page, updating here will reflect on all mapped pages
            </span>
          }
          <div class="col-md-12">
            <input type="text" class="form-control" placeholder="Key" name="key" [(ngModel)]="key"
              #keyUI="ngModel" required [disabled]="editedObject">
              @if (f.submitted && keyUI.invalid) {
                <div class="error-message">
                  @if (keyUI.errors.required) {
                    <div>
                      Key is required
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          <div class="row justify-content-center mt-3">
            <div class="col-md-12">
              <textarea class="form-control" placeholder="Value" name="value" [(ngModel)]="value"
              #valueUI="ngModel" required rows="5"></textarea>
              @if (f.submitted && valueUI.invalid) {
                <div class="error-message">
                  @if (valueUI.errors.required) {
                    <div>
                      Value is required
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          @if (!editedObject) {
            <div class="row justify-content-center mt-3">
              <div class="col-md-12">
                <input type="checkbox" id="isGlobal" name="isGlobal" [(ngModel)]="isGlobal">
                <label for="isGlobal" class="ml-2">Make this key global</label>
              </div>
            </div>
          }
          <div class="row form-group justify-content-center  mt-3">
            <div class="col-md-12" style="text-align: center;">
              <button type="submit" id="btn-win-popup-without-receipt-submit" class="btn">
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </ng-template>